import AbsComponent from "../AbsComponent";

export default class CharInfo extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
    }

    setting(_d, _d2, _parent){
        
        $(_parent).toggle(this.store.getState().isAllowed);
        if (!this.store.getState().isAllowed) {
            return;
        }
        
        
        _d = _d.data;

        let itsMe = window.myChar.id === _d2.data.id;

        let templ = $(`
            <div class="charater-view">
                <img src="${this.store.getState().config.staticPath}/img/photo/${_d2.data.clazz}.jpg" alt="" class="photo"/>
            </div>
            <div class="gem-wrap">
                <div class="gem-icon-bg">
                    <div class="gem-icon" >
                        <span class="pos1">${_d.soulshield_1?`<img src="${_d.soulshield_1.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos2">${_d.soulshield_2?`<img src="${_d.soulshield_2.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos3">${_d.soulshield_3?`<img src="${_d.soulshield_3.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos4">${_d.soulshield_4?`<img src="${_d.soulshield_4.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos5">${_d.soulshield_5?`<img src="${_d.soulshield_5.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos6">${_d.soulshield_6?`<img src="${_d.soulshield_6.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos7">${_d.soulshield_7?`<img src="${_d.soulshield_7.equip.item.icon_transparent}">`:``}</span>
                        <span class="pos8">${_d.soulshield_8?`<img src="${_d.soulshield_8.equip.item.icon_transparent}">`:``}</span>
                        <img src="${this.store.getState().config.staticPath}/img/blank.gif" alt="" class="pos" usemap="#gemIcon_pos">
                    </div>
                </div>
                <map name="gemIcon_pos">
                    <area shape="poly" alt="${_d.soulshield_1?.equip.item.name}" ${_d.soulshield_1?`data-tooltip="${_d.soulshield_1.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_1.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="35,3,78,3,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_2?.equip.item.name}" ${_d.soulshield_2?`data-tooltip="${_d.soulshield_2.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_2.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="78,3,108,34,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_3?.equip.item.name}" ${_d.soulshield_3?`data-tooltip="${_d.soulshield_3.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_3.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="108,34,108,78,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_4?.equip.item.name}" ${_d.soulshield_4?`data-tooltip="${_d.soulshield_4.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_4.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="108,78,78,108,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_5?.equip.item.name}" ${_d.soulshield_5?`data-tooltip="${_d.soulshield_5.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_5.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="78,108,35,108,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_6?.equip.item.name}" ${_d.soulshield_6?`data-tooltip="${_d.soulshield_6.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_6.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="35,108,2,78,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_7?.equip.item.name}" ${_d.soulshield_7?`data-tooltip="${_d.soulshield_7.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_7.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="2,78,2,34,56,56"/>
                    <area shape="poly" alt="${_d.soulshield_8?.equip.item.name}" ${_d.soulshield_8?`data-tooltip="${_d.soulshield_8.tooltip_string}" title="nc://bns.CharInfo/ItemTooltip?item=${_d.soulshield_8.tooltip_string}&compare=${itsMe?'false':'true'}"`:``} coords="2,34,35,3,56,56"/>
                </map>
            </div>
        `);

        templ.find('area').on('click', e => {
            let data = e.currentTarget.dataset?.tooltip;
            if (e.shiftKey && data) {
                location.href = 'nc://bns.Common/ItemPreview?item=' + data;
            }
        })
        $(_parent).empty().append(templ);
    }

    addEvents(){
    }

} // end of class